import * as e from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/CaretDoubleUp.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: m }));
o.displayName = "CaretDoubleUpIcon";
const s = o;
export {
  s as CaretDoubleUp,
  o as CaretDoubleUpIcon
};
